import React, { PureComponent } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

import { withT } from '../context/t';

const HoverStateContainer = styled.div``;

const NonHoverStateContainer = styled.div``;

const InputContainer = styled.div`
  display: inline-flex;
  padding: 2px;

  &:hover ${NonHoverStateContainer},
  ${HoverStateContainer} {
    display: none;
  }

  ${NonHoverStateContainer},
  &:hover ${HoverStateContainer} {
    display: block;
  }
`;

let nInputs = 0;

export class RatingInput extends PureComponent {
  static defaultProps = {
    onSelection: Function.prototype,
  };

  name = `${nInputs++}_rating_input`;

  state = {
    hoverValue: null,
    focused: false,
  };

  handleChange = evt =>
    this.props.onSelection(parseInt(evt.currentTarget.value, 10));

  renderRatingTag(hover) {
    let ratingText = this.props.t(`default`);
    let value;

    if (hover) {
      value = this.state.hoverValue;
    } else {
      value = this.props.value;
    }

    if (typeof value === 'number') {
      ratingText = this.props.t(`ratings.${value}`);
    }

    return (
      <div className="rating-input__tag">
        <span>{ratingText}</span>
      </div>
    );
  }

  renderVisualRadio(value, radioValue) {
    if (typeof value === 'number' && value >= radioValue) {
      return <div className="rating-input__icon--filled" />;
    }

    return <div className="rating-input__icon" />;
  }

  render() {
    const { value, label, className } = this.props;
    const { hoverValue } = this.state;

    const ratings = this.props.t(`ratings`, { returnObjects: true });
    const targetLabel = this.props.t(label);

    return (
      <div className={className}>
        <fieldset
          className={classNames('rating-input', {
            'rating-input--active': this.state.focused,
          })}
          onFocus={() => this.setState({ focused: true })}
          // react don't support on focus out, we need to use this to determine
          onBlur={e => {
            // focus is leaving the container so do something interesting here
            if (!e.currentTarget.contains(e.relatedTarget)) {
              this.setState({ focused: false });
            }
          }}
        >
          <div className="rating-input__hidden-legend">{targetLabel + ':'}</div>
          <InputContainer className="rating-input__input-container">
            <span className="rating-input__descriptor">
              {targetLabel + ':'}
            </span>
            {ratings.map((rating, radioValue) => {
              const checked = value === radioValue;

              return (
                <label
                  className="rating-input__star"
                  key={rating}
                  onMouseEnter={() => this.setState({ hoverValue: radioValue })}
                >
                  <div className="rating-input__hidden-input">
                    <input
                      onChange={this.handleChange}
                      type="radio"
                      value={radioValue}
                      name={this.name}
                      checked={checked}
                    />
                    <span>{rating}</span>
                  </div>
                  <NonHoverStateContainer>
                    {this.renderVisualRadio(value, radioValue)}
                  </NonHoverStateContainer>
                  <HoverStateContainer>
                    {this.renderVisualRadio(hoverValue, radioValue)}
                  </HoverStateContainer>
                </label>
              );
            })}
            <NonHoverStateContainer>
              {this.renderRatingTag()}
            </NonHoverStateContainer>
            <HoverStateContainer>
              {this.renderRatingTag(true)}
            </HoverStateContainer>
          </InputContainer>
        </fieldset>
      </div>
    );
  }
}

export default withT('answerStructure')(RatingInput);
